import React from "react";
import { Link } from "react-router-dom"
import { format } from "date-fns"
import { reorderDots, brokenLink } from "components/Icons"
import StatusChangeDropdown from "components/StatusChangeDropdown";
import { JOB_STATES_DISPLAY } from "../../../../utils/constants";

const VrDraftingJobServiceRow = ({
  jobService, index, disableDrag, reloadData
}) => {
  const {
    id, attributes:
    {
      state,
      job_id,
      job_no,
      for_project_x,
      project_x_job_no,
      job_address,
      highlighted,
      label: job_type,
      primary_surveyor_name,
      primary_vr_draftsman_name,
      checked_out_at,
      client_due_date,
      client_due_date_overdue,
      job_has_multiple_job_services,
    }
  } = jobService

  const clientDueDateObj = new Date(client_due_date)
  const currentDate = new Date()
  const dueDateOverdue = client_due_date_overdue
  const tomorrow = new Date()

  tomorrow.setDate(currentDate.getDate() + 1);
  const dueTomorrow = tomorrow.toLocaleDateString() === clientDueDateObj.toLocaleDateString()
  const displayJobNo = for_project_x ? project_x_job_no : job_no
  const jobStateDisplay = JOB_STATES_DISPLAY[state]?.text

  const dueDateHandler = () => {
    if (!client_due_date) return ``;
    if (dueTomorrow) return `bg-yellow`;
    if (dueDateOverdue || highlighted) return `bg-coral`;

    return ""
  }

  return (
    <>
      <td className="bg-white">
        { !disableDrag && (
          <img src={reorderDots} style={{ width: 20 }} />
        )}
      </td>
      <td className={`${highlighted && "bg-coral"}`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{displayJobNo}</Link>
      </td>
      <td className={`${highlighted && "bg-coral"}`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{job_address}</Link>
      </td>
      <td className={`${highlighted && "bg-coral"}`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{job_type}</Link>
      </td>
      <td className={`${highlighted && "bg-coral"} text-left`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{primary_surveyor_name}</Link>
      </td>
      <td className={`${highlighted && "bg-coral"} text-center`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{checked_out_at ? format(new Date(checked_out_at), "dd MMM yyyy") : ""}</Link>
      </td>
      <td className={`${highlighted && "bg-coral"} text-left`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{primary_vr_draftsman_name}</Link>
      </td>
      <StatusChangeDropdown job={jobService} reloadData={reloadData} updatableStates={[]} updatableOptions={[]} />
      <td className={`${dueDateHandler()} text-center`}>
        <Link to={`/jobs/${job_id}/job_services/${id}`} className="link-no-decoration">{client_due_date}</Link>
      </td>
      <td className={`${highlighted && "bg-coral"}`}>
        {job_has_multiple_job_services && <img src={brokenLink} className="icon-size-18" id="has-child-jobs-icon" />}
      </td>
      <td className={`${highlighted && "bg-coral"}`}>
        <div className="d-flex align-items-center justify-content-end">
          <Link to={`/jobs/${job_id}/job_services/${id}`}>Details</Link>
        </div>
      </td>
    </>
  );
}

export default VrDraftingJobServiceRow